module.exports = __webpack_public_path__ + "static/media/loco.1fc1dcc8.png";